import { cn, TypographySubtle } from '@seen/ui'
import type { ReactNode } from 'react'
import { Skeleton } from '#src/components/core/Skeleton.tsx'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

export interface InboxRowTextProps {
  notificationItem: NotificationItem
  children: ReactNode
  isLoading?: boolean
  badges?: ReactNode
}

export function InboxRowText({
  notificationItem,
  children,
  isLoading = false,
  badges,
}: InboxRowTextProps): ReactNode {
  const hasUnread = !notificationItem.read_at

  return (
    <div className="flex min-w-0 flex-1 items-center gap-1.5">
      {hasUnread && (
        <div className="size-2 shrink-0 rounded-full bg-blue-300" />
      )}
      {!isLoading && (
        <div className="flex min-w-0 flex-1 items-center gap-1.5">
          <TypographySubtle
            className={cn(
              `line-clamp-1 font-medium break-all`,
              !!notificationItem.read_at && 'font-normal text-muted-foreground'
            )}
          >
            {children}
          </TypographySubtle>
          {badges}
        </div>
      )}
      {isLoading && (
        <div className="h-5 w-32 py-0.5">
          <Skeleton className="size-full" />
        </div>
      )}
    </div>
  )
}
